export const AddToChart = 'AddtoChart';
export const AddToFav = 'AddToFav';
export const RemoveFavItem = 'RemoveFavItem';
export const RemoveChartItem = 'RemoveChartItem';
export const IncreaseItem = 'IncreaseItem';
export const DecreaseItem = 'DecreaseItem';